var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: !_vm.scormUrl,
          expression: "!scormUrl",
        },
      ],
      ref: "scormcomponent",
      staticClass:
        "h-100p yxtbiz-kng-scorm-chapter-content pr over-hidden yxtbiz-kng-scorm-player",
    },
    [
      _vm.scormUrl
        ? [
            _vm.isMultipleChapters
              ? [
                  !_vm.showShapter
                    ? _c(
                        "div",
                        {
                          staticClass: "component-icon-btn showchapter-btn",
                          on: {
                            click: function ($event) {
                              _vm.showShapter = 1
                            },
                          },
                        },
                        [_c("i", { staticClass: "icons-scorm-showchapter" })]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      ref: "divchapterlist",
                      staticClass: "h-100p chapter-content-list",
                      class: { "showchapter-list": _vm.showShapter },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "chapter-list-title ellipsis",
                          attrs: { title: _vm.title },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.title) + "\n        "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "chapter-content-list-chapters" },
                        [
                          _c("yxt-tree", {
                            staticClass:
                              "mt16 lh-1 yxtbiz-kng-scorm-chapter-content height-68vh",
                            attrs: {
                              data: _vm.courseChapterContent,
                              "node-key": "treeId",
                              "default-expand-all": "",
                              "current-node-key": _vm.currentChapter.treeId,
                            },
                            on: { "current-change": _vm.chooseChapter },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var data = ref.data
                                    return _c(
                                      "span",
                                      { staticClass: "custom-tree-node" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "chaptername ellipsis",
                                            attrs: { title: data.chapterName },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(data.chapterName) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              1372176847
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm.showShapter
                        ? _c(
                            "div",
                            {
                              staticClass: "component-icon-btn hidechapter-btn",
                              on: {
                                click: function ($event) {
                                  _vm.showShapter = 0
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icons-scorm-hidechapter",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              : _vm._e(),
            _c(
              "div",
              {
                ref: "divchaptercontent",
                staticClass: "h-100p chapter-content",
                class: { "chapter-content-showchapters": _vm.showShapter },
              },
              [
                _c("iframe", {
                  staticClass:
                    "iframe over-hidden h-100p yxtbiz-kng-scorm-chapter-content",
                  attrs: {
                    allowfullscreen: "true",
                    webkitallowfullscreen: "true",
                    mozallowfullscreen: "true",
                    src: _vm.scormUrl,
                  },
                }),
              ]
            ),
          ]
        : _vm._e(),
      _c("yxtbiz-watermark", {
        attrs: {
          option: _vm.watermarkConfig,
          "app-code": "kng",
          version: "v2",
        },
      }),
      !_vm.isFullScreen
        ? _c(
            "div",
            {
              ref: "divFullscreen",
              staticClass: "component-icon-btn fullscreen-btn",
              on: {
                mouseup: function ($event) {
                  return _vm.onFullscreenChange(1, $event)
                },
              },
            },
            [
              _c("yxtf-svg", {
                staticClass: "v-mid svgicon",
                attrs: { "remote-url": _vm.stcSvg, "icon-class": "fscreen" },
              }),
              _c("div", { staticClass: "fullscreen-tip" }, [
                _c("span", { staticClass: "v-mid d-in-block ml8 mr8" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("pc_kng_scorm_btn_fullscreen1" /* 全屏模式 */)
                      )
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isFullScreen
        ? _c(
            "div",
            {
              ref: "divExitFullscreen",
              staticClass: "component-icon-btn fullscreen-btn",
              on: {
                mouseup: function ($event) {
                  return _vm.onFullscreenChange(0, $event)
                },
              },
            },
            [
              _c("yxtf-svg", {
                staticClass: "v-mid svgicon",
                attrs: { "remote-url": _vm.stcSvg, "icon-class": "escreen" },
              }),
              _c("div", { staticClass: "fullscreen-tip" }, [
                _c("span", { staticClass: "v-mid d-in-block ml8 mr8" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "pc_kng_scorm_btn_fullscreen_exit" /* 退出全屏 */
                        )
                      )
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }